module.exports = __webpack_public_path__ + "static/media/04 Generali Gospodarstwo Rolne OWU.71603e6f.pdf";